import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { getUsersAsOptions } from '../../services/companyUsers';
import { onQuerySuccess } from '../../utils/queryResponse';
import FormSelect from '../forms/formSelect';
import { filterUsers } from '../../utils/userHelper';
import Avatar from '../avatar';

const usersMap = new Map()

/**
 * Photo + name for an assignee row. react-select uses this for BOTH the open
 * menu and the closed control, so the picked person keeps their photo.
 *
 * Avatar falls back to initials on its own, so an option whose source didn't
 * carry `avatarUrl` still renders correctly — nothing here needs to branch on
 * whether the photo is present.
 */
const formatAssigneeLabel = ({ label, avatarUrl }) => (
    <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
        <Avatar size={22} name={label} src={avatarUrl} />
        {/* The control is narrow (three assignee pickers sit side by side), so
            a long name ellipsises rather than pushing the photo out of view. */}
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
    </span>
)

const AssigneeSelect = ({ value, isMulti, assigneesOptions, filterRole, isLoading, ...rest  }) => {

    let filtered = filterUsers(assigneesOptions, filterRole) ?? []
    // const [options, setOptions] = useState()

    // const { data, isLoading } = useQuery(['users-option'], () => assigneesOptions ? {} : getUsersAsOptions())

    // useEffect(() => {
    //     onQuerySuccess(data, (result) => {
    //         if (result.length > 0) {
    //             setOptions(
    //                 result.map(d => {
    //                     usersMap.set(d.id, d.fullName)
    //                     return { value: d.id, label: d.fullName }
    //                 })
    //             )
                
    //         }
    //     })
    // }, [data])

    return (
        <FormSelect isMulti={isMulti} formatOptionLabel={formatAssigneeLabel} {...rest}
            value={
                isMulti ? value?.map(v => ({value: v, label: usersMap.get(v)})) :
                    (filtered.find(opt => opt.value === value) || null)
            }
            options={filtered}
            isLoading={isLoading}
            isClearable
        />
    )
}

export default AssigneeSelect